import { Component } from '@opten/gin-tonic/helpers/compiler';
import Masonry from 'masonry-layout';

@Component({ className: 'js-masonry-container' })
export class MasonryComponent {
	constructor(private element: HTMLElement) {
		const instance = new Masonry(this.element, {
			itemSelector: '.js-masonry-item',
			columnWidth: '.js-masonry-sizer',
			percentPosition: true,
			horizontalOrder: true
		});

		document.addEventListener('lazyloaded', () => {
			instance.layout();
		});

		const collapse = this.element.closest('.js-collapse');
		if (collapse) {
			collapse.addEventListener('shown.opten.collapse', () => {
				instance.layout();
			});
		}
	}
}
